import * as React from "react";
import { createContext, PropsWithChildren, useContext, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "~/Services/Request";
import { Options } from "~/Types/Options";
import { isAuthenticated } from "~/Services/Authentication";

const OptionsContext = createContext<Options>({} as any);

export const useOptionsContext = () => {
    return useContext(OptionsContext);
};

// right now options only return for logged in users, can we change that in the future?
// it would mean anyone can see the values returned.
// maybe we need an unauthenticated options endpoint
export const OptionsProvider = (props: PropsWithChildren) => {
    const { data } = useQuery({
        queryKey: ["admin/options"],
        queryFn: () => {
            return get<Options>("/admin/options");
        },
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        enabled: isAuthenticated(),
    });

    // opal chat will read this out of local storage for tracking analytics in segment
    useEffect(() => {
        if (data?.optiAI?.opalChat && data?.telemetry?.segmentWriteKeyFrontend) {
            localStorage.setItem("ai-chat:ANALYTICS_STORAGE_KEY", data.telemetry.segmentWriteKeyFrontend);
        }
    }, [data?.optiAI?.opalChat, data?.telemetry?.segmentWriteKeyFrontend]);

    if (!isAuthenticated()) {
        return <>{props.children}</>;
    }

    if (!data) {
        return null;
    }

    return <OptionsContext.Provider value={data}>{props.children}</OptionsContext.Provider>;
};
